export const shouldLoad = () => true;
export function requestCacheHeaders({
  response
}) {
  const etag = response.xhr.headers.get('ETag');

  if (etag) {
    return {
      'if-none-match': etag
    };
  }

  const lastModified = response.xhr.headers.get('Last-Modified');

  if (lastModified) {
    return {
      'if-modified-since': lastModified
    };
  }

  return {};
}